import styled from '@emotion/styled';

const WarningText = styled('span')(({ theme }) => ({
  color: theme.palette.warning.main,
}));

export default WarningText;
